/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PriceAlertDirectionEnum {
    Up = 'up',
    Down = 'down'
}

export function PriceAlertDirectionEnumFromJSON(json: any): PriceAlertDirectionEnum {
    return PriceAlertDirectionEnumFromJSONTyped(json, false);
}

export function PriceAlertDirectionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceAlertDirectionEnum {
    return json as PriceAlertDirectionEnum;
}

export function PriceAlertDirectionEnumToJSON(value?: PriceAlertDirectionEnum | null): any {
    return value as any;
}

